import { Component, Input } from '@angular/core';
import { IValuePair, Language } from './common';

@Component({
    selector: 'app-diploma-supplement-value-pairs',
    templateUrl: './value-pairs.component.html',
    styleUrls: ['./diploma-supplement.component.scss']
})
export class DiplomaSupplementValuePairsComponent {
    @Input() items: IValuePair[] = [];
    @Input() translate: (key: string, language: Language) => string;

    toArray(row: IValuePair) {
        return [row.lv, row.en];
    }

    isEmpty(value: any) {
        return value === undefined || value === null;
    }
}
